import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  ProgressBar,
} from "react-bootstrap";
import { TbCurrencyTaka } from "react-icons/tb";
import { LinkContainer } from "react-router-bootstrap";
import {
  GiExpense,
  GiReceiveMoney,
  GiPayMoney,
  GiTakeMyMoney,
  GiProfit,
} from "react-icons/gi";
import { RiCurrencyFill, RiMoneyDollarBoxFill } from "react-icons/ri";
// import { RiMoneyDollarBoxFill } from "react-icons/ri";
import { FaUserGroup, FaUsers } from "react-icons/fa6";
import { BsFillPassportFill } from "react-icons/bs";
import { LiaPassportSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import axios from "axios";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../features/user/userSlice";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getAllDailyExpenses } from "../features/dailyexpense/dailyExpenseSlice";
import { getAllSalaries } from "../features/salary/salarySlice";

const Analytics = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [agentCount, setAgentCount] = useState(0);
  const [passportCount, setPassportCount] = useState(0);
  const [visaCount, setVisaCount] = useState(0);

  const [dailyExpense, setDailyExpense] = useState(0);
  const [dailyExpenseAllTime, setDailyExpenseAllTime] = useState(0);
  const [salaryExpense, setSalaryExpense] = useState(0);
  const [deliveryOfficePayment, setDeliveryOfficePayment] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);

  const [salaryExpenseMonthly, setSalaryExpenseMonthly] = useState(0);

  const [extraIncome, setExtraIncome] = useState(0);
  const [dueCollection, setDueCollection] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [remainingBalance, setRemainingBalance] = useState(0);

  const [extraMonthlyIncome, setExtraMonthlyIncome] = useState(0);
  const [dueCollectionMonthlyIncome, setDueCollectionMonthlyIncome] =
    useState(0);
  const [totalMonthlyIncome, setTotalMonthlyIncome] = useState(0);

  const [returnedPassportAmount, setReturnedPassportAmount] = useState(0);

  const [error, setError] = useState(null);

  const [allExpenses, setAllExpenses] = useState([]);
  const [allSalaries, setAllSalaries] = useState([]);

  const [progressNow, setProgressNow] = useState(0);

  const {
    dailyExpenses,
    islistLoading,
    isListError,
    listErrorMessage,
    isListSuccess,
  } = useSelector((state) => state.dailyExpense);

  const [selectDateFrom, setSelectDateFrom] = useState("");
  const [selectDateTo, setSelectDateTo] = useState("");

  const [searchByName, setSearchByName] = useState("");
  const [searchByMonth, setSearchByMonth] = useState("");

  const {
    salaries,
    isListLoading,
    isListError: isSalaryListError,
    listErrorMessage: salaryListErrorMessage,
    isListSuccess: isSalaryListSuccess,
  } = useSelector((state) => state.salary);

  // user Selector
  const { userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    if (!userInfo) {
      // toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    } else if (userInfo.permissions?.includes("analytics") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  useEffect(() => {
    // Fetch the agent count from the server
    const fetchAgentCount = async () => {
      try {
        const response = await axios.get("/api/v1/agent/count");
        // const data = await response.json();
        // setAgentCount(data.count);
        setAgentCount(response.data.count);
      } catch (error) {
        console.error("Failed to fetch agent count:", error);
      }
    };
    fetchAgentCount();
  }, []);

  useEffect(() => {
    // Fetch the passport count from the server
    const fetchPassportCount = async () => {
      try {
        const response = await axios.get("/api/v1/passport/count");
        // const data = await response.json();
        // setPassportCount(data.count);
        setPassportCount(response.data.count);
      } catch (error) {
        console.error("Failed to fetch passport count: ", error);
      }
    };
    fetchPassportCount();
  }, []);

  useEffect(() => {
    // Fetch the visa count from the server
    const fetchVisaCount = async () => {
      try {
        const response = await axios.get("/api/v1/visa/count");
        setVisaCount(response.data.count);
      } catch (error) {
        console.error("Failed to fetch visa count: ", error);
      }
    };
    fetchVisaCount();
  }, []);

  // useEffect to add the dailyExpense, salaryExpense and deliveryOfficePayment to get the totalExpense
  useEffect(() => {
    const fetchTotalExpense = async () => {
      try {
        // fetch the dailyExpense of present date
        const dailyExpenseResponse = await axios.get(
          "/api/v1/dailyExpense/total"
        );
        // console.log("daily expense response:", dailyExpenseResponse.data);
        // alert(dailyExpenseResponse.data.data.total);
        setDailyExpense(dailyExpenseResponse.data.data.total);

        // fetch the dailyExpense of all time
        const dailyExpenseAllTimeResponse = await axios.get(
          "/api/v1/dailyExpense/allTimeTotal"
        );
        // alert(dailyExpenseAllTimeResponse.data.data.total);
        setDailyExpenseAllTime(dailyExpenseAllTimeResponse.data.data.total);

        // fetch the salaryExpense
        const salaryExpenseResponse = await axios.get(
          "/api/v1/salaryPayment/total"
        );
        setSalaryExpense(salaryExpenseResponse.data.data.total);

        // fetch the deliveryOfficePaymentTotal
        const deliveryOfficePaymentResponse = await axios.get(
          "/api/v1/passport/deliveryofficepaymentstotal"
        );
        // alert(deliveryOfficePaymentResponse.data.data.total);
        setDeliveryOfficePayment(deliveryOfficePaymentResponse.data.data.total);

        // Calculate the totalExpense
        const totalExpense =
          dailyExpenseAllTimeResponse.data.data.total +
          salaryExpenseResponse.data.data.total +
          deliveryOfficePaymentResponse.data.data.total;
        setTotalExpense(totalExpense);
      } catch (error) {
        console.error("Failed to fetch total expense:", error);
      }
    };
    fetchTotalExpense();
  }, []);

  // useEffect to get the Monthly Salary Expense
  useEffect(() => {
    const fetchMonthlySalaryExpense = async () => {
      try {
        const salaryExpenseResponse = await axios.get('/api/v1/salaryPayment/currentmonth');
        // alert(salaryExpenseResponse.data.data.total)
        setSalaryExpenseMonthly(salaryExpenseResponse.data.data.total)
      } catch (error) {
        console.error("Failed to fetch total income: ", error);
      }
    }
    fetchMonthlySalaryExpense()
  }, [])

  // useEffect to add the income and dueCollection to get the Total Balance
  useEffect(() => {
    const fetchTotalIncome = async () => {
      try {
        const extraIncomeResponse = await axios.get("/api/v1/income/total");
        setExtraIncome(extraIncomeResponse.data.data.total);

        const dueCollectionResponse = await axios.get(
          "/api/v1/passport/duecollection/total"
        );
        // alert(dueCollectionResponse.data.data.total);
        console.log("Due Collection Response:", dueCollectionResponse);
        setDueCollection(dueCollectionResponse.data.data.total);

        // fetch the returnedPassportAmount
        const returnedPassportAmountResponse = await axios.get(
          "/api/v1/passport/duecollection/returnedtotal"
        );
        // alert(returnedPassportAmountResponse.data.data.total);
        setReturnedPassportAmount(
          returnedPassportAmountResponse.data.data.total
        );

        const totalIncome =
          extraIncomeResponse.data.data.total +
          dueCollectionResponse.data.data.total -
          returnedPassportAmountResponse.data.data.total;
        setTotalIncome(totalIncome);
      } catch (error) {
        console.error("Failed to fetch total income: ", error);
      }
    };
    fetchTotalIncome();
  }, []);

  // useEffect to add the total monthly income from dueCollection and extraIncome
  useEffect(() => {
    const fetchTotalMonthlyIncome = async () => {
      try {
        const extraMonthlyIncomeResponse = await axios.get(
          "/api/v1/income/currentmonth"
        );
        // alert(extraMonthlyIncomeResponse.data.data.total);
        setExtraMonthlyIncome(extraMonthlyIncomeResponse.data.data.total);

        const dueCollectionMonthlyIncomeResponse = await axios.get(
          "/api/v1/passport/duecollection/monthlyincome"
        );
        // alert(dueCollectionMonthlyIncomeResponse.data.data.total);
        setDueCollectionMonthlyIncome(
          dueCollectionMonthlyIncomeResponse.data.data.total
        );

        const totalMonthlyIncome =
          extraMonthlyIncomeResponse.data.data.total +
          dueCollectionMonthlyIncomeResponse.data.data.total;
        setTotalMonthlyIncome(totalMonthlyIncome);
      } catch (error) {
        console.error("Failed to fetch total monthly income: ", error);
      }
    };
    fetchTotalMonthlyIncome();
  }, []);

  // useEffect to calculate the remaining balance
  useEffect(() => {
    const remainingBalance = totalIncome - totalExpense;
    setRemainingBalance(remainingBalance);
  }, [totalIncome, totalExpense]);

  useEffect(() => {
    if (userInfo) {
      if (isListError) {
        // toast.error(listErrorMessage, { position: "top-center" });
      } else if (isListSuccess) {
        setAllExpenses(dailyExpenses);
      } else {
        dispatch(getAllDailyExpenses());
      }
    }
  }, [
    dispatch,
    isListSuccess,
    isListError,
    // listErrorMessage,
    dailyExpenses,
    userInfo,
  ]);

  useEffect(() => {
    if (userInfo) {
      if (isSalaryListError) {
        // toast.error(salaryListErrorMessage, { position: "top-center" });
      } else if (isSalaryListSuccess) {
        setAllSalaries(salaries);
      } else {
        dispatch(getAllSalaries());
      }
    }
  }, [
    dispatch,
    isSalaryListSuccess,
    isSalaryListError,
    // salaryListErrorMessage,
    salaries,
    userInfo,
  ]);

  // Update ProgressBar from 0 to 100 on page load stop after 100
  useEffect(() => {
    const interval = setInterval(() => {
      setProgressNow((oldProgress) => {
        if (oldProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        const newProgress = oldProgress + 4;
        return newProgress;
      });
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const currentMonth = moment().format("MMMM");

  return (
    <Container fluid className="my-4">
      {userInfo && userInfo.userType !== "admin" && (
        <>
          <Row className="mt-5">
            <Col sm={12} md={12} lg={12}>
              <h1 className="text-center my-5" style={{ fontSize: "70px" }}>
                Welcome to
              </h1>
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={12} lg={12}>
              <h1
                className="text-center my-5"
                style={{
                  fontSize: "90px",
                  fontWeight: "bold",
                  color: "#3c8dbc",
                }}
              >
                Northeast Overseas LTD.
                {/* Administration ERP System */}
              </h1>

              <img
                style={{
                  maxWidth: "500px",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                src="/img/hello.gif"
                alt="Hello"
              />
            </Col>
          </Row>
        </>
      )}
      {userInfo && userInfo.userType === "admin" && (
        <div>
          <Row className="mb-4 d-flex align-items-center">
            <Card
              className="rounded-4 border"
              style={{ backgroundColor: "#e6edf1" }}
            >
              <h2 className="text-center text-dark fw-bold my-3">
                Welcome to <span style={{ color: "#5c91dc" }}>NorthEast</span>{" "}
                Dashboard
              </h2>
            </Card>
          </Row>

          <Row className="mb-4">
            <Col sm={12} md={6} lg={4}>
              <Card className="shadow rounded-4 border-0 fw-bold text-black my-2">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="fw-bold">Total Income</Card.Title>
                    </Col>

                    <Col
                      className="d-flex justify-content-end"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <GiReceiveMoney style={{ color: "green" }} size="45" />
                    </Col>
                  </Row>

                  <ProgressBar
                    style={{ height: "10px" }}
                    className="mb-3"
                    variant="success"
                    now={progressNow}
                  />

                  <Row>
                    <Card.Text className="text-center fw-bold" as="h5">
                      <TbCurrencyTaka className="mb-1" />
                      {totalIncome}
                    </Card.Text>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col sm={12} md={6} lg={4}>
              <Card className="shadow rounded-4 border-0 fw-bold text-black my-2">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="fw-bold">Total Expense</Card.Title>
                    </Col>

                    <Col
                      className="d-flex justify-content-end"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <GiPayMoney style={{ color: "red" }} size="45" />
                    </Col>
                  </Row>

                  <ProgressBar
                    style={{ height: "10px" }}
                    className="mb-3"
                    variant="danger"
                    now={progressNow}
                  />

                  <Row>
                    <Card.Text className="text-center fw-bold" as="h5">
                      <TbCurrencyTaka className="mb-1" />
                      {totalExpense}
                    </Card.Text>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* Old Design For Analytics Card */}
            {/* <Col sm={12} md={6} lg={4}>
              <Card
                className="shadow rounded-4 text-black fw-bold my-2 bg-danger"
                style={{ backgroundColor: "#FF6100" }}
              >
                <Card.Body>
                  <Row>
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="text-center fw-bold">
                        Total Expense
                      </Card.Title>
                      <Card.Text className="text-center">
                        <TbCurrencyTaka className="mb-1" />
                        {totalExpense}
                      </Card.Text>
                    </Col>

                    <Col
                      className="d-flex align-items-center"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <GiPayMoney size="40" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col> */}

            {/* <Col sm={12} md={6} lg={4}>
              <Card
                className="shadow rounded-4 text-black my-2 fw-bold"
                style={{ backgroundColor: "#60C81F" }}
              >
                <Card.Body>
                  <Row>
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="text-center fw-bold">
                        Remaining Balance
                      </Card.Title>
                      <Card.Text className="text-center">
                        <TbCurrencyTaka className="mb-1" />
                        {remainingBalance}
                      </Card.Text>
                    </Col>

                    <Col
                      className="d-flex align-items-center"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <GrMoney size="40" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col> */}

            <Col sm={12} md={6} lg={4}>
              <Card className="shadow rounded-4 border-0 fw-bold text-black my-2">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="fw-bold">
                        Remaining Balance
                      </Card.Title>
                    </Col>

                    <Col
                      className="d-flex justify-content-end"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      {/* if the remaining balance is negative, the color of the icon will be red */}
                      <GrMoney
                        style={{
                          color: remainingBalance <= 0 ? "red" : "green",
                        }}
                        size="45"
                      />
                    </Col>
                  </Row>

                  <ProgressBar
                    style={{ height: "10px" }}
                    className="mb-3"
                    variant={remainingBalance <= 0 ? "danger" : "success"}
                    now={progressNow}
                  />

                  <Row>
                    <Card.Text className="text-center fw-bold" as="h5">
                      <TbCurrencyTaka className="mb-1" />
                      {remainingBalance}
                    </Card.Text>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            {/* <Col sm={12} md={6} lg={6}>
              <Card
                className="shadow rounded-4 fw-bold text-black my-2"
                style={{ background: "#FF6100" }}
              >
                <Card.Body className="">
                  <Row>
                    <Col className="" sm={12} md={6} lg={8}>
                      <Card.Title className="text-center fw-bold">
                        Daily Expense
                      </Card.Title>
                      {error ? (
                        <p>Error Fetching Response : {error}</p>
                      ) : (
                        <Card.Text className="text-center fw-bold">
                          <TbCurrencyTaka className="mb-1" />
                          {dailyExpense}
                        </Card.Text>
                      )}
                    </Col>

                    <Col
                      className="d-flex align-items-center"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <GiExpense size="40" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col> */}

            <Col sm={12} md={6} lg={4}>
              <Card className="shadow rounded-4 border-0 fw-bold text-black my-2">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="fw-bold">
                        Monthly Income
                      </Card.Title>
                    </Col>

                    <Col
                      className="d-flex justify-content-end"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <GiProfit style={{ color: "green" }} size="45" />
                    </Col>
                  </Row>

                  <ProgressBar
                    style={{ height: "10px" }}
                    className="mb-3"
                    variant="success"
                    now={progressNow}
                  />

                  <Row>
                    {/* {currentMonth} {totalMonthlyIncome} */}
                    <Col sm={12} md={6} lg={6}>
                      {currentMonth}
                    </Col>
                    <Col
                      sm={12}
                      md={6}
                      lg={6}
                      className="d-flex justify-content-end"
                    >
                      <Card.Text className="text-center fw-bold">
                        <TbCurrencyTaka className="mb-1" />
                        {totalMonthlyIncome}
                      </Card.Text>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col sm={12} md={6} lg={4}>
              <Card className="shadow rounded-4 border-0 fw-bold text-black my-2">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="fw-bold">Daily Expense</Card.Title>
                    </Col>

                    <Col
                      className="d-flex justify-content-end"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <GiExpense style={{ color: "red" }} size="45" />
                    </Col>
                  </Row>

                  <ProgressBar
                    style={{ height: "10px" }}
                    className="mb-3"
                    variant="danger"
                    now={progressNow}
                  />

                  <Row>
                    <Card.Text className="text-center fw-bold" as="h5">
                      <TbCurrencyTaka className="mb-1" />
                      {dailyExpense}
                    </Card.Text>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* <Col sm={12} md={6} lg={6}>
              <Card
                className="shadow rounded-4 fw-bold text-black my-2"
                style={{ background: "#FF6100" }}
              >
                <Card.Body>
                  <Row>
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="text-center fw-bold">
                        Salary Expense
                      </Card.Title>
                      <Card.Text className="text-center">
                        <TbCurrencyTaka className="mb-1" />
                        {salaryExpense}
                      </Card.Text>
                    </Col>

                    <Col
                      className="d-flex align-items-center"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <GiTakeMyMoney size="40" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col> */}

            <Col sm={12} md={6} lg={4}>
              <Card className="shadow rounded-4 border-0 fw-bold text-black my-2">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="fw-bold">
                        Salary Expense
                      </Card.Title>
                    </Col>

                    <Col
                      className="d-flex justify-content-end"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <GiTakeMyMoney style={{ color: "red" }} size="45" />
                    </Col>
                  </Row>

                  <ProgressBar
                    style={{ height: "10px" }}
                    className="mb-3"
                    variant="danger"
                    now={progressNow}
                  />

                  {/* <Row>
                    <Card.Text className="text-center fw-bold" as="h5">
                      <TbCurrencyTaka className="mb-1" />
                      {salaryExpenseMonthly}
                    </Card.Text>
                  </Row> */}
                  <Row>
                    <Col sm={12} md={6} lg={6}>
                      {currentMonth}
                    </Col>
                    <Col
                      sm={12}
                      md={6}
                      lg={6}
                      className="d-flex justify-content-end"
                    >
                      <Card.Text className="text-center fw-bold">
                        <TbCurrencyTaka className="mb-1" />
                        {salaryExpenseMonthly}
                      </Card.Text>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mt-4">
            {/* <Col sm={12} md={4} lg={4}>
              <Card
                className="shadow rounded-4 text-black my-2 fw-bold bg-secondary"
              >
                <Card.Body>
                  <Row>
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="text-center fw-bold">
                        Total Agents
                      </Card.Title>
                      <Card.Text className="text-center">
                        {agentCount}
                      </Card.Text>
                    </Col>

                    <Col
                      className="d-flex align-items-center"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <FaUserGroup size="40" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col> */}

            <Col sm={12} md={6} lg={4}>
              <Card className="shadow rounded-4 border-0 fw-bold text-black my-2">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="fw-bold">Total Agents</Card.Title>
                    </Col>

                    <Col
                      className="d-flex justify-content-end"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <FaUsers style={{ color: "#5c91dc" }} size="45" />
                    </Col>
                  </Row>

                  <ProgressBar
                    style={{ height: "10px" }}
                    className="mb-3"
                    variant="info"
                    now={progressNow}
                  />

                  <Row>
                    <Card.Text className="text-center fw-bold" as="h5">
                      {/* <TbCurrencyTaka className="mb-1" /> */}
                      {agentCount}
                    </Card.Text>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* <Col sm={12} md={4} lg={4}>
              <Card
                className="shadow rounded-4 text-black fw-bold my-2 bg-secondary"
              >
                <Card.Body>
                  <Row>
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="text-center fw-bold">
                        Total Passports
                      </Card.Title>
                      <Card.Text className="text-center">
                        {passportCount}
                      </Card.Text>
                    </Col>

                    <Col
                      className="d-flex align-items-center"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <BsFillPassportFill size="40" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col> */}

            <Col sm={12} md={6} lg={4}>
              <Card className="shadow rounded-4 border-0 fw-bold text-black my-2">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="fw-bold">
                        Total Passports
                      </Card.Title>
                    </Col>

                    <Col
                      className="d-flex justify-content-end"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <BsFillPassportFill
                        style={{ color: "#5c91dc" }}
                        size="45"
                      />
                    </Col>
                  </Row>

                  <ProgressBar
                    style={{ height: "10px" }}
                    className="mb-3"
                    variant="info"
                    now={progressNow}
                  />

                  <Row>
                    <Card.Text className="text-center fw-bold" as="h5">
                      {/* <TbCurrencyTaka className="mb-1" /> */}
                      {passportCount}
                    </Card.Text>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* <Col sm={12} md={4} lg={4}>
              <Card
                className="shadow rounded-4 text-black fw-bold my-2 bg-secondary"
              >
                <Card.Body>
                  <Row>
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="text-center fw-bold">
                        Total Visas
                      </Card.Title>
                      <Card.Text className="text-center">{visaCount}</Card.Text>
                    </Col>

                    <Col
                      className="d-flex align-items-center"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <LiaPassportSolid size="40" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col> */}

            <Col sm={12} md={6} lg={4}>
              <Card className="shadow rounded-4 border-0 fw-bold text-black my-2">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={12} md={6} lg={8}>
                      <Card.Title className="fw-bold">Total Visas</Card.Title>
                    </Col>

                    <Col
                      className="d-flex justify-content-end"
                      sm={12}
                      md={6}
                      lg={4}
                    >
                      <LiaPassportSolid
                        style={{ color: "#5c91dc" }}
                        size="45"
                      />
                    </Col>
                  </Row>

                  <ProgressBar
                    style={{ height: "10px" }}
                    className="mb-3"
                    variant="info"
                    now={progressNow}
                  />

                  <Row>
                    <Card.Text className="text-center fw-bold" as="h5">
                      {/* <TbCurrencyTaka className="mb-1" /> */}
                      {visaCount}
                    </Card.Text>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col sm={12} md={6} lg={6}>
              <Card style={{ backgroundColor: "#74a2e3" }} className="px-2">
                <Card.Header
                  className="text-center text-black p-3 fw-bold"
                  style={{ backgroundColor: "#74a2e3" }}
                  as="h5"
                >
                  Daily Expense List
                </Card.Header>
                <Table responsive bordered hover>
                  <thead className="text-center">
                    <tr>
                      <th>Expense Amount</th>
                      <th>Expense Description</th>
                      <th>Expense Date</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {islistLoading ? (
                      <Loader />
                    ) : (
                      <>
                        {allExpenses && allExpenses.length <= 0 ? (
                          <tr>
                            <td colSpan={3}>
                              <h6>No expenses added!</h6>
                            </td>
                          </tr>
                        ) : (
                          <>
                            {/* Create a shallow copy before sorting */}
                            {[...allExpenses]
                              .sort(
                                (a, b) =>
                                  new Date(b.createdAt) - new Date(a.createdAt)
                              ) // Sort by latest first
                              .slice(0, 8) // Take the first 8 after sorting
                              .map((dailyExpense) => (
                                <tr key={dailyExpense?._id}>
                                  <td>{dailyExpense.amount}</td>
                                  <td>{dailyExpense.description}</td>
                                  <td>
                                    {moment(dailyExpense.createdAt).format(
                                      "DD-MMMM-YYYY"
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </>
                        )}
                      </>
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>

            <Col sm={12} md={6} lg={6}>
              <Card style={{ backgroundColor: "#74a2e3" }} className="px-2">
                <Card.Header
                  className="text-center text-black p-3 fw-bold"
                  style={{ backgroundColor: "#74a2e3" }}
                  as="h5"
                >
                  Salary List
                </Card.Header>
                <Table responsive bordered hover>
                  <thead className="text-center">
                    <tr>
                      <th>Employee Name</th>
                      <th>Paid Amount</th>
                      <th>Month</th>
                    </tr>
                  </thead>

                  {isListLoading ? (
                    <Loader />
                  ) : (
                    <tbody className="text-center">
                      {allSalaries && allSalaries.length <= 0 ? (
                        <tr>
                          <td colSpan={3}>
                            <h6>No salaries added!</h6>
                          </td>
                        </tr>
                      ) : (
                        <>
                          {/* Sort by 'createdAt' descending and slice the last 8 salaries */}
                          {[...allSalaries]
                            .sort(
                              (a, b) =>
                                new Date(b.createdAt) - new Date(a.createdAt)
                            ) // Sort by latest first
                            .slice(0, 8) // Take the first 8 after sorting
                            .map((salary) => (
                              <tr
                                key={salary._id}
                                style={{ cursor: "pointer" }}
                              >
                                <td>{salary.employeeName}</td>
                                <td>{salary.amount}</td>
                                <td>{salary.monthOfPayment}</td>
                              </tr>
                            ))}
                        </>
                      )}
                    </tbody>
                  )}
                </Table>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </Container>
  );
};

export default Analytics;
